import { render, staticRenderFns } from "./TreatyModal.vue?vue&type=template&id=7d000f5c&scoped=true"
import script from "./TreatyModal.vue?vue&type=script&lang=js"
export * from "./TreatyModal.vue?vue&type=script&lang=js"
import style0 from "./TreatyModal.vue?vue&type=style&index=0&id=7d000f5c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d000f5c",
  null
  
)

export default component.exports